// Gallery data — events, concerts, festivals
// To add a new gig:
//   1. Upload photos to Cloudinary
//   2. Add a new entry below with the Cloudinary URLs

export interface GalleryPhoto {
  url: string;       // Cloudinary URL
  caption?: string;
}

export interface GalleryGig {
  slug: string;
  title: string;        // Event / show name
  date: string;         // ISO date: "2025-08-15"
  venue: string;        // Venue name
  location?: string;    // "New York, NY"
  tags: string[];       // ["Festival", "DJ", "Outdoor"]
  coverImage: string;   // Hero image for the gig card
  photos: GalleryPhoto[];
  description?: string;
  published: boolean;
}

export const galleryGigs: GalleryGig[] = [
  {
    slug: "sample-festival-2025",
    title: "Sample Festival 2025",
    date: "2025-08-15",
    venue: "The Venue",
    location: "New York, NY",
    tags: ["Festival", "Outdoor", "DJ"],
    coverImage: "https://placehold.co/800x500/1a1b1e/f97316?text=Festival+2025",
    description:
      "A multi-stage outdoor festival featuring live music, DJs, and art installations. Photographed over two full days.",
    published: true,
    photos: [
      { url: "https://placehold.co/800x1000/1a1b1e/f97316?text=Photo+1", caption: "Main stage" },
      { url: "https://placehold.co/1000x700/111113/f97316?text=Photo+2", caption: "Crowd energy" },
      { url: "https://placehold.co/700x900/1a1b1e/f97316?text=Photo+3" },
      { url: "https://placehold.co/900x600/111113/f97316?text=Photo+4", caption: "DJ set" },
      { url: "https://placehold.co/600x800/1a1b1e/f97316?text=Photo+5" },
      { url: "https://placehold.co/1000x650/111113/f97316?text=Photo+6", caption: "Art installation" },
    ],
  },
  {
    slug: "warehouse-concert-2024",
    title: "Warehouse Concert",
    date: "2024-11-22",
    venue: "The Warehouse",
    location: "Brooklyn, NY",
    tags: ["Concert", "Indoor", "Underground"],
    coverImage: "https://placehold.co/800x500/1a1b1e/a855f7?text=Warehouse+Concert",
    description:
      "Intimate warehouse concert series. Low light, high energy.",
    published: true,
    photos: [
      { url: "https://placehold.co/900x700/1a1b1e/a855f7?text=Photo+1" },
      { url: "https://placehold.co/700x950/111113/a855f7?text=Photo+2", caption: "Stage lights" },
      { url: "https://placehold.co/800x600/1a1b1e/a855f7?text=Photo+3" },
      { url: "https://placehold.co/600x800/111113/a855f7?text=Photo+4", caption: "The crowd" },
      { url: "https://placehold.co/1000x700/1a1b1e/a855f7?text=Photo+5" },
    ],
  },
  {
    slug: "community-meetup-spring-2025",
    title: "Tech Meetup: Spring Edition",
    date: "2025-04-10",
    venue: "Co-working Space",
    location: "Manhattan, NY",
    tags: ["Meetup", "Tech", "Community"],
    coverImage: "https://placehold.co/800x500/1a1b1e/22c55e?text=Tech+Meetup",
    description:
      "Monthly tech community meetup — demos, networking, and lightning talks.",
    published: true,
    photos: [
      { url: "https://placehold.co/800x600/1a1b1e/22c55e?text=Photo+1", caption: "Lightning talks" },
      { url: "https://placehold.co/600x900/111113/22c55e?text=Photo+2" },
      { url: "https://placehold.co/900x650/1a1b1e/22c55e?text=Photo+3", caption: "Networking" },
      { url: "https://placehold.co/700x850/111113/22c55e?text=Photo+4" },
    ],
  },
];

// ── Helpers ──────────────────────────────────────────────────────────────────

export function getPublishedGigs(): GalleryGig[] {
  return galleryGigs
    .filter((g) => g.published)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
}

export function getGigBySlug(slug: string): GalleryGig | undefined {
  return galleryGigs.find((g) => g.slug === slug && g.published);
}

export function getGigsByTag(tag: string): GalleryGig[] {
  return getPublishedGigs().filter((g) =>
    g.tags.map((t) => t.toLowerCase()).includes(tag.toLowerCase())
  );
}

export function getAllGigTags(): string[] {
  return Array.from(new Set(galleryGigs.flatMap((g) => g.tags))).sort();
}
